import classNames from 'classnames';
import { useEffect, useState } from 'react';
import { QuestionRecord } from 'src/types/Quiz';
import styles from './quiz-follow-up-field.module.scss';

const QuizFollowUpField = (question: QuestionRecord) => {
    const { answerList, userAnswers, questionText } = question;
    const [selectedIndexes, setSelectedIndexes] = useState<number[]>([]);

    // Set existing answer(s)
    useEffect(() => {
        let selectedAnswerIds: string[] | null = null;
        if (userAnswers.length > 0) {
            selectedAnswerIds = userAnswers.map((a) => a.answerId);
        }
        if (Array.isArray(selectedAnswerIds)) {
            const newSelectedIndexes = selectedAnswerIds.reduce(
                (acc, selectedAnswerId) => [
                    ...acc,
                    answerList.findIndex(
                        (a) => a.answerId === selectedAnswerId,
                    ),
                ],
                [] as number[],
            );
            setSelectedIndexes(newSelectedIndexes);
        }
    }, [userAnswers, answerList]);

    return selectedIndexes.length > 0 ? (
        <div className={classNames(styles['quiz-field-header'])}>
            {/* Title */}
            <p className={classNames(styles['question-text'], 'p2 highlight')}>
                {questionText}
            </p>
            {/* Previous Answer */}
            <div className={styles['answer--wrapper']}>
                {selectedIndexes.map((i) => (
                    <p
                        key={i}
                        className={classNames(
                            styles['answer-text'],
                            'p2 highlight',
                        )}
                    >
                        {answerList[i].answerText}
                    </p>
                ))}
            </div>
        </div>
    ) : null;
};

export default QuizFollowUpField;
